export default "__VITE_ASSET__DmlcgoYs__"